// extracted by mini-css-extract-plugin
export default {"container":"QUIG9s"};